import { createApp } from 'vue'
import App from './App.vue'
import Router from './router/index.js'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './assets/less/index.less'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from '@/store/index'
import VueParticles from 'vue-particles'
import request from '@/request/request'
import { ElMessageBox } from 'element-plus'
import { loading, schoolChage, getBase64, checkMobileOrPc } from '@/utils/util'
import moent from 'moment'

const app = createApp(App);
app.use(Router).use(store).use(ElementPlus, { locale: zhCn }).use(VueParticles).mount('#app');
app.config.globalProperties.$request = request;
app.config.globalProperties.$moent = moent
app.config.globalProperties.$elLoading = { loading };
app.config.globalProperties.$util = { schoolChage, getBase64, checkMobileOrPc };
app.config.globalProperties.$elMessageBox = ElMessageBox
app.config.globalProperties.$icons = []

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
    app.config.globalProperties.$icons.push(key)
}

